import { useCallback, useContext, useState } from 'react'
import TabSelector from '../buttons/TabSelector'
import Button from '../buttons/Button'
import { simulatorContext } from '../../service/SimulatorContext'
import SimulatorDesktopMenu from './SimulatorDesktopMenu';
import Input from '../input/Input';
export default function SimulatorSubHeader() {
    const { handleAddKid, addKidDisabled, tab, setTab, stockMarket, setStockMarket } = useContext(simulatorContext);


    const tabsOptions = [
        { label: "תרומה חודשית", id: "monthly-donation-button", onClick: () => { setTab(0) } },
        { label: "החזר חודשי", id: "monthly-return-button", onClick: () => { setTab(1) } }
    ]

    const handleUpdateStockMarket = useCallback((key) => {
        return (e) => {
            setStockMarket(prev => ({ ...prev, [key]: Number(e) }))
        }
    }, [setStockMarket])


    return (
        <>
            <div className="frame-tab-menu-wrapper">
                <TabSelector tabs={tabsOptions} current={tab} />
                {(stockMarket.enabled && tab === 0) &&
                    <div className='stock-market-inputs'>
                        <Input type="number"
                            value={stockMarket.marketInterest}
                            label={'רווח צפוי בשוק ההון'}
                            onChange={handleUpdateStockMarket('marketInterest')}
                            style={{ maxWidth: 'max-content', flex: '1 1 ', minWidth: 107 }}
                            min="0" max="100" errorText={'אחוזים מ 0 עד 100'}
                            sign="%"
                        />
                        <Input type="number" value={stockMarket.loanInterest}
                            label={'ריבית צפוייה בהלוואה בנקאית'}
                            onChange={handleUpdateStockMarket('loanInterest')}
                            style={{ maxWidth: 'max-content', flex: '1.4 1', minWidth: 107 }}
                            min="0" max="100" errorText={'אחוזים מ 0 עד 100'}
                            sign="%"
                        />
                        <Input type="number" value={stockMarket.managementFee}
                            label={'דמי ניהול מהצבירה'}
                            onChange={handleUpdateStockMarket('managementFee')}
                            style={{ maxWidth: 'max-content', flex: '2 1', minWidth: 107 }}
                            min="0" max="100" errorText={'אחוזים מ 0 עד 100'}
                            sign="%"
                        />
                    </div>
                }
                <Button size='small' className={(tab === 0) ? '' : 'mobile'} disabled={addKidDisabled} onClick={handleAddKid} icon="plus-circle" label='הוסף ילד/ה' />
            </div>
            <SimulatorDesktopMenu />
        </>

    )
}
